import { Controller } from "@hotwired/stimulus"

/**
 * 出庫フォーム用のStimulusコントローラー
 */
export default class extends Controller {
  static targets = ["employeeSelect", "employeeIdField"]
  static values = { confirmMessage: String, clearConfirmMessage: String }

  /**
   * コントローラー初期化時に実行
   */
  connect() {
  }

  /**
   * 確認ボタンクリック時にフォームを送信（通常の保存）
   */
  submitForm() {
    if (!confirm(this.confirmMessageValue)) {
      return
    }

    this.syncEmployeeId()
    const form = document.getElementById('outbound-form')
    if (form) {
      form.requestSubmit()
    }
  }

  /**
   * フォームの入力欄をすべてクリア
   */
  clearForm() {
    if (!confirm(this.clearConfirmMessageValue)) {
      return
    }

    const form = document.getElementById('outbound-form')
    if (!form) return

    // すべてのnumber型inputを空にする
    form.querySelectorAll('input[type="number"]').forEach(input => {
      input.value = ''
      // inputイベントを発火させて計算コントローラーに通知
      input.dispatchEvent(new Event('input', { bubbles: true }))
    })
  }

  /**
   * 出庫者選択の値をhidden fieldに反映
   */
  syncEmployeeId() {
    if (this.hasEmployeeSelectTarget && this.hasEmployeeIdFieldTarget) {
      this.employeeIdFieldTarget.value = this.employeeSelectTarget.value
    }
  }
}
